import styled from "styled-components";
import zIndexTypes from "../../../theme/zIndexTypes";
import {
  mediaMinWidth,
  mediaMaxWidth,
  mediaMaxHeight,
} from "../../../theme/mediaQueriesTemplates";

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${zIndexTypes.modal};
  display: flex;
  justify-content: center;
  align-items: center;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.fadeIn {
    animation-name: fadeIn;
  }

  &.animated {
    animation-duration: 0.4s;
    animation-fill-mode: both;
  }

  ${mediaMaxHeight.phone} {
    align-items: unset;
  }

  ${mediaMaxWidth.tablet} {
    align-items: unset;
  }
`;
ModalBackdrop.displayName = "ModalBackdrop";

interface IModalWrapperProps {
  iOS: boolean;
}

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 800px;
  height: ${(props: IModalWrapperProps) => (props.iOS ? "370px" : "420px")};
  z-index: ${zIndexTypes.modal};
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.smallDesktop} {
    margin-left: unset;
    width: calc(100vw - 30px);
  }

  ${mediaMaxWidth.tablet} {
    top: 10px;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
    padding: 10px 10px;
  }

  ${mediaMaxHeight.phone} {
    top: 10px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop} {
    width: 95%;
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 500px;
  height: calc(100% - 55px);
  margin: 0 auto;
  position: relative;
  overflow: hidden;

  ${mediaMaxWidth.tablet} {
    width: 400px;
  }

  ${mediaMaxWidth.phone} {
    width: 85vw;
  }

  a {
    text-align: center;
  }
`;
Form.displayName = "Form";

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;
  margin: 20px 0 0 0;
  text-align: justify;

  span {
    font-weight: 700;
  }

  ${mediaMaxWidth.phone} {
    margin: 10px 0 0 0;
  }
`;

export const Field = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  margin-bottom: 75px;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  &.animated.delay {
    animation-delay: 0.1s;
  }
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  width: 100%;
  resize: none;
  padding: 10px;
  height: 8em;
  position: relative;
  margin: 20px auto;
  color: #333;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  ${mediaMaxWidth.phone} {
    height: 7em;
  }
`;
TextInput.displayName = "TextInput";

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;

  button {
    margin: 5px 10px;

    ${mediaMaxWidth.phone} {
      margin: 0 10px;
    }
  }

  ${mediaMaxWidth.phone} {
    bottom: 0;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  &.animated.delay {
    animation-delay: 0.3s;
  }
`;

export const Error = styled.div`
  position: absolute;
  bottom: 30px;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #79D9D9;
  font-weight: 600;

  ${mediaMaxWidth.phone} {
    bottom: 10px;
  }
`;
Error.displayName = "Error";

export const StepCount = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 0.8em;
`;
